import _ from 'lodash';
import { Flex } from 'components/base/layout-components';
import MultipleAvatars from 'components/MultipleAvatars';
import { getContributorAvatarUrl } from 'common/constants/Avatars';
import TextWithTooltipOnEllipsis from 'components/base/TextWithTooltipOnEllipsis';
import { providerLogos } from 'common/services/sensors.service';
import Text from 'components/base/Text';
import Tooltip from '@material-ui/core/Tooltip';
import styled from 'styled-components';
import { getColor } from 'common/constants/_colors';
import { LBButton, LBXIcon } from '@linearb/buzz';

const PrimaryWrapper = styled(Flex)`
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  background-color: ${getColor('melrose')};
  border-radius: 3rem;
  padding: 0.4rem 0.6rem;
  margin-left: 1.2rem;
`;

const Wrapper = styled(Flex)`
  align-items: center;
  cursor: ${({ disableClicks }) => (disableClicks ? 'default' : 'pointer')};
  ${({ isSelected, disableClicks }) =>
    isSelected
      ? `
    border-bottom: 1px solid ${getColor('botticelli')};
    padding: 1rem;
    ${
      disableClicks
        ? ''
        : `
    :hover{
      > div {
        background-color: ${getColor('titanWhite')};
        border-radius: 0.4rem;
      }
    }
  `
    }`
      : ''};
`;
const Primary = () => (
  <PrimaryWrapper>
    <Text color='white' weight='500' size='small'>
      Primary
    </Text>
  </PrimaryWrapper>
);

const User = ({ avatarUrl, name, email, sensor = {}, isPrimary }) => (
  <Flex width='100%' items='center'>
    <MultipleAvatars
      avatars={[
        {
          name,
          url: avatarUrl
        }
      ]}
      disableTooltip
      changeCursor={!isPrimary}
    />
    <TextWithTooltipOnEllipsis
      width='15rem'
      ellipsisAfter='14.5rem'
      pr='1.2rem'
      pl='1.2rem'
      size='large'
      weight='400'
    >
      {name}
    </TextWithTooltipOnEllipsis>
    <TextWithTooltipOnEllipsis
      width='17rem'
      ellipsisAfter='16.5rem'
      size='large'
      color='shuttleGray'
      weight='400'
    >
      {email || 'N/A'}
    </TextWithTooltipOnEllipsis>
    {sensor && (
      <>
        {providerLogos[sensor.sensor_name] && (
          <img
            className='size-4'
            alt=''
            src={providerLogos[sensor.sensor_name]}
          />
        )}
        <Text pl='0.5rem' size='large' color='shuttleGray' weight='400'>
          {sensor.name}
        </Text>
      </>
    )}
    {isPrimary && <Primary />}
  </Flex>
);

const GitUser = ({
  id,
  name,
  email,
  sensor,
  isPrimary,
  onRemove,
  onClick,
  isSelected = false
}) => {
  const disableClicks = !onClick || isPrimary;
  const showRemoveButton = !isPrimary && !!onRemove;
  return (
    <Wrapper
      disableClicks={disableClicks}
      onClick={disableClicks ? _.noop : () => onClick(id)}
      isSelected={isSelected}
    >
      <div className='flex flex-row items-center p-2 gap-2'>
        <Tooltip
          data-test='primary-tooltip'
          placement='top-start'
          title='Set as primary'
          disableHoverListener={!isSelected || disableClicks}
        >
          <span>
            <User
              avatarUrl={getContributorAvatarUrl({ id })}
              name={name}
              email={email}
              sensor={sensor}
              isPrimary={isPrimary}
            />
          </span>
        </Tooltip>
        {showRemoveButton && (
          <LBButton
            variant='link'
            size='icon'
            onClick={event => {
              event.stopPropagation();
              onRemove(id);
            }}
          >
            <LBXIcon />
          </LBButton>
        )}
      </div>
    </Wrapper>
  );
};

export default GitUser;
